import overviewStyle from './overview.module.css';

import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import _ from "lodash";

// Service
import AuthOrganizationService from "../../../../services/Auth.Organization.service";

// Components
import InlineTitle from '../../../../components/InlineTitle';

// Slice
import { uiActions } from "../../../../stores/slice/ui";
import { t } from 'i18next';

// Default data
const defaultOverviewData = {
  overview: {
    device: { total: 0, ap: 0, sw: 0, gw: 0 },
    license: {
      total: 0,
      used: 0,
      unused: { inactive: 0, active: 0 }
    }
  },
  expiring: { ap: 0, sw: 0, gw: 0 },
  summary: {
    usedDevices: { ap: 0, sw: 0, gw: 0 },
    unusedInactiveLicenses: { ap: 0, sw: 0, gw: 0 }
  }
};

const TopOverviewContainer = ({ tabList, changeTab, filterData, overviewData }) => {
  const changeTabAndFilterData = (who, type) => {
    filterData(who, type);
    (who === tabList[1].value) ? changeTab(tabList[1]) : changeTab(tabList[2]);
  };

  return (
    <div className={overviewStyle['top-overview-container']}>
      <Row>
        <Col className={overviewStyle['devices-status-container']}>
          <div className={overviewStyle['sub-status-container']}>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('dc258b7538')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[1].value, 'all')}>
                {overviewData.overview.device.total}
              </a>
            </div>
          </div>

          <div className={overviewStyle['sub-status-container']}>
            <div>
              <img className='mx-3' src='../img/v2/icon/device_ap.png' width={65} />
            </div>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('130d9e4fb0')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[1].value, 'ap')}>
                {overviewData.overview.device.ap}
              </a>
            </div>
          </div>

          <div className={overviewStyle['sub-status-container']}>
            <div>
              <img className='mx-3' src="../img/v2/icon/device_switch.png" width={65} />
            </div>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('0052efad5d')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[1].value, 'sw')}>
                {overviewData.overview.device.sw}
              </a>
            </div>
          </div>

          <div className={overviewStyle['sub-status-container']}>
            <div>
              <img className='mx-3' src="../img/v2/icon/device_gateway.png" width={65} />
            </div>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('a0ea006dc2')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[1].value, 'gw')}>
                {overviewData.overview.device.gw}
              </a>
            </div>
          </div>
        </Col>

        <div className={overviewStyle['devices-v-line-container']}></div>

        <Col className={overviewStyle['licenses-status-container']}>
          <div className={overviewStyle['sub-status-container']}>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('e6c8b4aa80')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[2].value, 'total')}>
                {overviewData.overview.license.total}
              </a>
            </div>
          </div>

          <div className={overviewStyle['sub-status-container']}>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('0c714f58b7')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[2].value, 'used')}>
                {overviewData.overview.license.used}
              </a>
            </div>
          </div>

          <div className={overviewStyle['sub-status-container']}>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('57c5db4082')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[2].value, ', unusedInactive')}>
                {overviewData.overview.license.unused.inactive}
              </a>
            </div>
          </div>

          <div className={overviewStyle['sub-status-container']}>
            <div className={overviewStyle['number-container']}>
              <div className={overviewStyle['number-title']}>{t('c78b6db4ce')}</div>
              <a href="#" className={overviewStyle['number-count']} onClick={() => changeTabAndFilterData(tabList[2].value, 'unusedActive')}>
                {overviewData.overview.license.unused.active}
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const BottomOverviewContainer = ({ tabList, changeTab, filterData, overviewData }) => {
  const changeTabAndFilterData = (who, type) => {
    filterData(who, type);
    (who === tabList[1].value) ? changeTab(tabList[1]) : changeTab(tabList[2]);
  };

  return (
    <div className={overviewStyle['bottom-overview-container']}>
      <Row>
        <Col xl={6} className={overviewStyle['bottom-sub-container']}>
          <InlineTitle label={t('3b07cfc39e')} />
          <Table responsive className={overviewStyle['overview-table-container']}>
            <thead>
              <tr>
                <th>#</th>
                <th>{t('402d4d2bce')}</th>
                <th>{t('a4b6321e28')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ width: "50px" }}>1</td>
                <td>DBA-series</td>
                <td><a href="#">{overviewData.expiring.ap}</a></td>
              </tr>
              <tr>
                <td style={{ width: "50px" }}>2</td>
                <td>DBS-2000</td>
                <td><a href="#">{overviewData.expiring.sw}</a></td>
              </tr>
              <tr>
                <td style={{ width: "50px" }}>3</td>
                <td>DBG-series</td>
                <td><a href="#">{overviewData.expiring.gw}</a></td>
              </tr>
            </tbody>
          </Table>
        </Col>

        <Col xl={6} className={overviewStyle['bottom-sub-container']}>
          <InlineTitle label='SUMMARY' />
          <Table responsive className={overviewStyle['overview-table-container']}>
            <thead>
              <tr>
                <th>#</th>
                <th>{t('402d4d2bce')}</th>
                <th>{t('7d04cd4dd9')}</th>
                <th>{t('57c5db4082')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ width: "50px" }}>1</td>
                <td>DBA-series</td>
                <td><a href="#/">{overviewData.summary.usedDevices.ap}</a></td>
                <td><a
                  href="#/"
                  onClick={() => changeTabAndFilterData(tabList[2].value, 'unusedInactiveAp')}
                >{overviewData.summary.unusedInactiveLicenses.ap}</a></td>
              </tr>
              <tr>
                <td style={{ width: "50px" }}>2</td>
                <td>DBS-2000</td>
                <td><a href="#/">{overviewData.summary.usedDevices.sw}</a></td>
                <td><a
                  href="#/"
                  onClick={() => changeTabAndFilterData(tabList[2].value, 'unusedInactiveSwitch')}
                >{overviewData.summary.unusedInactiveLicenses.sw}</a></td>
              </tr>
              <tr>
                <td style={{ width: "50px" }}>3</td>
                <td>DBG-series</td>
                <td><a href="#/">{overviewData.summary.usedDevices.gw}</a></td>
                <td><a
                  href="#/"
                  onClick={() => changeTabAndFilterData(tabList[2].value, 'unusedInactiveGateway')}
                >{overviewData.summary.unusedInactiveLicenses.gw}</a></td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

const Overview = (props) => {
  const {
    tabList,
    changeTab,
    filterData,
    isOrgLevel,
    messages,
    setMessages
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const pageContext = useSelector(state => state.pageContext);
  const [overviewData, setOverviewData] = useState({ ...defaultOverviewData });

  let selectedOrg = null;
  if (isOrgLevel) {
    selectedOrg = pageContext.selectedOrg;
  } else {
    selectedOrg = pageContext.si;
  }

  const transformData = (rawData) => {
    const copiedDefaultOverviewData = _.cloneDeep(defaultOverviewData);

    // Overview
    copiedDefaultOverviewData.overview.device.total = rawData.deviceCount.total || 0;
    copiedDefaultOverviewData.overview.device.ap = rawData.deviceCount.ap || 0;
    copiedDefaultOverviewData.overview.device.sw = rawData.deviceCount.switch || 0;
    copiedDefaultOverviewData.overview.device.gw = rawData.deviceCount.gateway || 0;

    copiedDefaultOverviewData.overview.license.total = rawData.licenseCount.total || 0;
    copiedDefaultOverviewData.overview.license.used = rawData.licenseCount.used || 0;
    copiedDefaultOverviewData.overview.license.unused.inactive = rawData.licenseCount.unusedInactive.total || 0;
    copiedDefaultOverviewData.overview.license.unused.active = rawData.licenseCount.unusedActive || 0;

    // Expiring
    copiedDefaultOverviewData.expiring.ap = rawData.expireDeviceCount.ap || 0;
    copiedDefaultOverviewData.expiring.sw = rawData.expireDeviceCount.switch || 0;
    copiedDefaultOverviewData.expiring.gw = rawData.expireDeviceCount.gateway || 0;

    // Summary
    copiedDefaultOverviewData.summary.usedDevices.ap = rawData.usedDeviceCount.ap || 0;
    copiedDefaultOverviewData.summary.usedDevices.sw = rawData.usedDeviceCount.switch || 0;
    copiedDefaultOverviewData.summary.usedDevices.gw = rawData.usedDeviceCount.gateway || 0;
    copiedDefaultOverviewData.summary.unusedInactiveLicenses.ap = rawData.licenseCount.unusedInactive.ap || 0;
    copiedDefaultOverviewData.summary.unusedInactiveLicenses.sw = rawData.licenseCount.unusedInactive.switch || 0;
    copiedDefaultOverviewData.summary.unusedInactiveLicenses.gw = rawData.licenseCount.unusedInactive.gateway || 0;

    return copiedDefaultOverviewData;
  };

  useEffect(() => {
    const fetchOverviewData = async () => {
      setOverviewData({ ...defaultOverviewData });
      dispatch(uiActions.showInnerSpinner());
      const response = await AuthOrganizationService.getLicenseOverview(selectedOrg.id);

      if (!response.error) {
        setOverviewData(transformData(response.data));
      } else {
        setMessages({
          ...messages,
          error: response.error.code,
          success: null,
        });
      }

      dispatch(uiActions.hideInnerSpinner());
    };

    fetchOverviewData();
  }, [selectedOrg.id]);

  return (
    <div className={`${overviewStyle['overview-container']} layout-container layout-container--column layout-container--fluid`}>
      <InlineTitle label={t('f7f09cf0f2')} isNonUnderline={true} />
      <TopOverviewContainer
        tabList={tabList}
        changeTab={changeTab}
        filterData={filterData}
        overviewData={overviewData}
      />
      <BottomOverviewContainer
        tabList={tabList}
        changeTab={changeTab}
        filterData={filterData}
        overviewData={overviewData}
      />
    </div>
  );
};

export default Overview;